import React, { useState } from 'react';
import { X, GripVertical, Plus, Trash2, Edit2, Save } from 'lucide-react';

function GestionDestaques({ destaques, paquetes, onUpdateDestaque, onRefresh }) {
  const [destaqueActivo, setDestaqueActivo] = useState(destaques[0]?.id || null);
  const [editandoNombre, setEditandoNombre] = useState(null);
  const [nuevoNombre, setNuevoNombre] = useState('');
  const [paquetesSeleccionados, setPaquetesSeleccionados] = useState([]);
  const [busqueda, setBusqueda] = useState('');

  // Obtener paquetes asignados al destaque actual
  const paquetesAsignados = paquetes.filter(p => 
    p.destaques?.some(d => d.id === destaqueActivo)
  );

  // Obtener paquetes NO asignados al destaque actual
  const paquetesDisponibles = paquetes.filter(p => 
    !p.destaques?.some(d => d.id === destaqueActivo) &&
    (p.titulo.toLowerCase().includes(busqueda.toLowerCase()) ||
     p.destino_nombre?.toLowerCase().includes(busqueda.toLowerCase()))
  );

  const destaqueSeleccionado = destaques.find(d => d.id === destaqueActivo);

  // Guardar cambio de nombre
  const handleGuardarNombre = async () => {
    if (!nuevoNombre.trim()) return;
    
    await onUpdateDestaque(editandoNombre, { nombre: nuevoNombre });
    setEditandoNombre(null);
    setNuevoNombre('');
    onRefresh();
  };

  // Agregar paquetes seleccionados al destaque
  const handleAgregarPaquetes = async () => {
    if (paquetesSeleccionados.length === 0) {
      alert('Selecciona al menos un paquete');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/destaques/asignar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          paqueteIds: paquetesSeleccionados,
          destaqueIds: [destaqueActivo]
        })
      });

      if (response.ok) {
        alert(`✅ ${paquetesSeleccionados.length} paquetes agregados`);
        setPaquetesSeleccionados([]);
        onRefresh();
      }
    } catch (error) {
      console.error('Error agregando paquetes:', error);
      alert('Error al agregar paquetes');
    }
  };

  // Quitar paquete del destaque
  const handleQuitarPaquete = async (paqueteId) => {
    if (!window.confirm('¿Quitar este paquete del destaque?')) return;

    try {
      const token = localStorage.getItem('token');
      // ✅ URL CORREGIDA: paquetes primero, destaques después
      const response = await fetch(`${process.env.REACT_APP_API_URL}/paquetes/${paqueteId}/destaques/${destaqueActivo}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        alert('✅ Paquete removido del destaque');
        onRefresh();
      } else {
        const error = await response.json();
        alert(error.message || 'Error al remover paquete');
      }
    } catch (error) {
      console.error('Error quitando paquete:', error);
      alert('Error al quitar paquete del destaque');
    }
  };

  if (destaques.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-8 text-center">
        <p className="text-gray-500">No hay destaques creados. Crea uno primero.</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-lg mt-8">

      {/* Tabs de Destaques */}
      <div className="border-b border-gray-200">
        <div className="flex overflow-x-auto">
          {destaques.map(destaque => {
            const cantidadPaquetes = paquetes.filter(p => 
              p.destaques?.some(d => d.id === destaque.id)
            ).length;

            return (
              <button
                key={destaque.id}
                onClick={() => setDestaqueActivo(destaque.id)}
                className={`px-6 py-3 border-b-2 font-medium text-sm whitespace-nowrap transition-colors flex items-center gap-2 ${
                  destaqueActivo === destaque.id
                    ? 'border-purple-600 text-purple-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                }`}
              >
                <span style={{ color: destaque.color }}>{destaque.icono}</span>
                <span>{destaque.nombre}</span>
                <span className="bg-gray-200 text-gray-700 px-2 py-0.5 rounded-full text-xs">
                  {cantidadPaquetes}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Contenido del Destaque Activo */}
      <div className="p-6">
        {/* Header con nombre editable */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            {editandoNombre === destaqueActivo ? (
              <div className="flex items-center gap-2">
                <input
                  type="text"
                  value={nuevoNombre}
                  onChange={(e) => setNuevoNombre(e.target.value)}
                  className="px-3 py-2 border border-gray-300 rounded-lg"
                  placeholder="Nuevo nombre"
                  autoFocus
                />
                <button
                  onClick={handleGuardarNombre}
                  className="p-2 text-green-600 hover:bg-green-50 rounded"
                >
                  <Save size={20} />
                </button>
                <button
                  onClick={() => {
                    setEditandoNombre(null);
                    setNuevoNombre('');
                  }}
                  className="p-2 text-gray-600 hover:bg-gray-50 rounded"
                >
                  <X size={20} />
                </button>
              </div>
            ) : (
              <>
                <span className="text-3xl" style={{ color: destaqueSeleccionado?.color }}>
                  {destaqueSeleccionado?.icono}
                </span>
                <h4 className="text-xl font-bold">{destaqueSeleccionado?.nombre}</h4>
                <button
                  onClick={() => {
                    setEditandoNombre(destaqueActivo);
                    setNuevoNombre(destaqueSeleccionado?.nombre || '');
                  }}
                  className="p-2 text-gray-600 hover:bg-gray-100 rounded"
                >
                  <Edit2 size={16} />
                </button>
              </>
            )}
          </div>
          <span className="text-sm text-gray-600">
            {paquetesAsignados.length} paquetes asignados
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Columna Izquierda: Paquetes Asignados */}
          <div>
            <h5 className="font-semibold text-gray-900 mb-3">
              ✅ Paquetes en este Destaque
            </h5>
            
            {paquetesAsignados.length === 0 ? (
              <div className="text-center py-8 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
                <p className="text-gray-500">No hay paquetes asignados aún</p>
              </div>
            ) : (
              <div className="space-y-2 max-h-96 overflow-y-auto">
              {paquetesAsignados.map(paquete => {
                // Formatear fecha
                const fechaSalida = paquete.fecha_salida 
                  ? new Date(paquete.fecha_salida).toLocaleDateString('es-AR', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric'
                    })
                  : 'Sin fecha';
                
                // Determinar color de disponibilidad
                const disponibilidad = paquete.disponibilidad || 0;
                const colorDisponibilidad = disponibilidad === 0 
                  ? 'text-red-600' 
                  : disponibilidad < 5 
                  ? 'text-orange-600' 
                  : 'text-green-600';
                
                // Formatear precio
                const moneda = paquete.moneda || '$';
                const precio = paquete.tarifa 
                  ? `${moneda} ${parseFloat(paquete.tarifa).toLocaleString('es-AR')}` 
                  : 'Sin precio';
                
                // Icono de transporte
                const iconoTransporte = paquete.transporte === 'Aéreo' || paquete.transporte === 'Aereo' 
                  ? '✈️' 
                  : '🚌';
                
                return (
                  <div
                    key={paquete.id}
                    className="flex items-center justify-between p-3 bg-green-50 border border-green-200 rounded-lg hover:bg-green-100 transition-colors"
                  >
                    <div className="flex items-center gap-3 flex-1">
                      <GripVertical size={16} className="text-gray-400 flex-shrink-0" />
                      
                      <div className="flex-1 min-w-0">
                        {/* Título y Destino */}
                        <p className="font-medium text-gray-900 truncate">{paquete.titulo}</p>
                        <p className="text-xs text-gray-600">{paquete.destino_nombre}</p>
                        
                        {/* Info adicional */}
                        <div className="flex flex-wrap items-center gap-3 mt-2 text-xs">
                          {/* Fecha */}
                          <span className="flex items-center gap-1 text-gray-700">
                            📅 {fechaSalida}
                          </span>
                          
                          {/* Disponibilidad */}
                          <span className={`flex items-center gap-1 font-semibold ${colorDisponibilidad}`}>
                            👥 {disponibilidad} cupos
                          </span>
                          
                          {/* Precio */}
                          <span className="flex items-center gap-1 text-blue-700 font-medium">
                            💰 {precio}
                          </span>
                          
                          {/* Transporte */}
                          <span className="flex items-center gap-1 text-gray-700">
                            {iconoTransporte} {paquete.transporte || 'N/A'}
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <button
                      onClick={() => handleQuitarPaquete(paquete.id)}
                      className="p-2 text-red-600 hover:bg-red-50 rounded flex-shrink-0 ml-2"
                      title="Quitar del destaque"
                    >
                      <X size={18} />
                    </button>
                  </div>
                );
              })}
            </div>
            )}
          </div>

          {/* Columna Derecha: Paquetes Disponibles */}
          <div>
            <div className="flex items-center justify-between mb-3">
              <h5 className="font-semibold text-gray-900">
                ➕ Agregar Paquetes
              </h5>
              {paquetesSeleccionados.length > 0 && (
                <button
                  onClick={handleAgregarPaquetes}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 text-sm flex items-center gap-2"
                >
                  <Plus size={16} />
                  Agregar ({paquetesSeleccionados.length})
                </button>
              )}
            </div>

            <input
              type="text"
              placeholder="Buscar paquetes..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-3"
            />

            {paquetesDisponibles.length === 0 ? (
              <div className="text-center py-8 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
                <p className="text-gray-500">
                  {busqueda ? 'No se encontraron paquetes' : 'Todos los paquetes ya están asignados'}
                </p>
              </div>
            ) : (
              <div className="space-y-2 max-h-96 overflow-y-auto">
                {paquetesDisponibles.slice(0, 20).map(paquete => (
                  <label
                    key={paquete.id}
                    className="flex items-center p-3 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
                  >
                    <input
                      type="checkbox"
                      checked={paquetesSeleccionados.includes(paquete.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setPaquetesSeleccionados(prev => [...prev, paquete.id]);
                        } else {
                          setPaquetesSeleccionados(prev => prev.filter(id => id !== paquete.id));
                        }
                      }}
                      className="mr-3 w-4 h-4 rounded border-gray-300"
                    />
                    <div>
                      <p className="font-medium text-gray-900">{paquete.titulo}</p>
                      <p className="text-xs text-gray-600">{paquete.destino_nombre}</p>
                    </div>
                  </label>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GestionDestaques;